import {updateInventoryNumber} from "../../../api";
import React, {useEffect, useState} from "react";
import {KTSVG} from "../../../../../../_metronic/helpers";
import {Modal} from "react-bootstrap-v5";
import Alert from "../../../../../components/alerts/Alert";

interface IEditInventoryNumberFormProps {
    msisdn: number | undefined
    inventoryNumber: string | undefined
    show: boolean
    handleClose: (updatedInventoryNumber?: string | undefined) => void
}

/**
 * Форма редактирования инвентарного номера SIM-карты
 */
export const EditInventoryNumberForm = ({msisdn, inventoryNumber, show, handleClose}: IEditInventoryNumberFormProps) => {
    const [message, setMessage] = useState('')
    const [isSubmitted, setIsSubmitted] = useState(false)
    const [updatedInventoryNumber, setUpdatedInventoryNumber] = useState(inventoryNumber)

    useEffect(() => {
        const getResponse = async () => {
            if (msisdn) {
                const response = await updateInventoryNumber(msisdn, updatedInventoryNumber || '')
                switch (response.status) {
                    case "ok":
                        return handleClose(updatedInventoryNumber)
                    case "error":
                        console.log(response)
                        setMessage("Сервер не смог обработать запрос. Попробуйте выполнить операцию позднее.")
                        return false
                }
            }
        }

        isSubmitted && getResponse()
    }, [isSubmitted])  // eslint-disable-line react-hooks/exhaustive-deps

    /**
     * Сброс формы при открытии модального окна
     */
    const reset = () => {
        setMessage('')
        setIsSubmitted(false)
    }

    return (
        <Modal
            className='modal'
            role='dialog'
            aria-hidden='true'
            tabIndex='-1'
            show={show}
            dialogClassName="modal-dialog modal-dialog-scrollable w-400px"
            onShow={reset}
            onHide={() => handleClose(updatedInventoryNumber)}
        >
            <div className='modal-header py-4'>
                <h3>Инвентарный номер устройства</h3>

                <div className='btn btn-sm btn-icon btn-active-color-primary' onClick={() => handleClose(updatedInventoryNumber)}>
                    <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-1'/>
                </div>
            </div>

            <div className='modal-body pt-5 px-9 center'>
                <div className="d-flex justify-content-between mb-0">
                    <input
                        style={{marginRight: "0.75rem"}}
                        className="form-control form-control-solid"
                        value={updatedInventoryNumber !== undefined ? updatedInventoryNumber : inventoryNumber}
                        onFocus={(event) => event.stopPropagation()}
                        onInput={(event) => setUpdatedInventoryNumber(event.currentTarget.value)}
                    >
                    </input>
                    <button className="btn btn-primary" onClick={() => setIsSubmitted(true)}>Сохранить</button>
                </div>
                <div>
                    {message && <Alert message={message}/>}
                </div>
            </div>
        </Modal>
    )
}
